import React, { useState } from "react";
import ProductsNavRow from "../rownavigator";

const CeilingClading = () => {
  // State management
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Data
  const ceiling_cladding = {
    ceiling_solutions: {
      name: "Ceiling Solutions",
      subcategories: {
        plaster_products: {
          name: "Plaster Products",
          products: [
            {
              name: "Finishing Plaster",
              image: "/assets/productimages/plaster.jpeg",
              use: "Ceiling materials",
              details: "25kg bag, ready-mixed formulation",
              price: "₹450",
            },
          ],
        },
        panels: {
          name: "Ceiling Panels",
          subcategories: {
            plasterboard: {
              name: "Plaster Board",
              products: [
                {
                  name: "12.5mm Plaster Board",
                  image: "/assets/productimages/plasterboard.jpeg",
                  use: "High-quality ceiling and partitioning panels",
                  details: "2400x1200mm, fire-resistant",
                  price: "₹1200",
                },
              ],
            },
            tiles: {
              name: "Ceiling Tiles",
              products: [
                {
                  name: "Acoustic Ceiling Tile",
                  image: "/assets/productimages/accousticeiling.webp",
                  use: "Ceiling covering",
                  details: "600x600mm, suspended grid system",
                  price: "₹300",
                },
              ],
            },
          },
        },

        // air_circulation: {
        //   name: "Air Circulation",
        //   options: {
        //     fans: {
        //       name: "Fans and Extractors",
        //       images: ["/assets/productimages/fans.jpg"],
        //       products: [
        //         {
        //           name: "Industrial Extractor Fan",
        //           image: "/assets/exhaustfans/fan1.png",
        //           use: "Air circulation systems",
        //           details: "High-capacity ventilation fan",
        //           price: "$149.99"
        //         },
        //         {
        //           name: "Axial fan REST D100 mesh back valve ERA",
        //           image: "/assets/exhaustfans/fan2.png",
        //           use: "Ventilation systems",
        //           details: "High-efficiency axial fan with back-draught valve",
        //           price: "$129.99"
        //         },
        //         {
        //           name: "Axial fan WIND D100 back-draught valve",
        //           image: "/assets/exhaustfans/fan3.png",
        //           use: "Ventilation systems",
        //           details: "Compact axial fan with back-draught valve for improved airflow",
        //           price: "$139.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan4.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan5.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan6.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan7.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan8.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan9.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },

        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan10.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan11.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan12.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //         {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan13.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         }, {
        //           name: "Axial fan WIND D120 back-draught valve",
        //           image: "/assets/exhaustfans/fan14.png",
        //           use: "Ventilation systems",
        //           details: "Larger axial fan with D120 back-draught valve for high efficiency",
        //           price: "$159.99"
        //         },
        //       ]
        //     }
        //   }
        // },
      },
    },
    screws_nails_fittings: {
      name: "Screws, Nails & Fittings",
      subcategories: {
        fixings: {
          name: "Plasterboard Fixings",
          products: [
            {
              name: "Drywall Screw Assortment",
              image: "/assets/productimages/plasterboardfixing.jpeg",
              use: "Installation components",
              details: "100-piece set, various lengths",
              price: "₹250",
            },
          ],
        },
      },
    },
  };

  // Helpers
  const handleCategoryClick = (key) => {
    setActiveCategory(key);
    setActiveSubcategory(null);
    setActiveOption(null);
  };

  const handleSubcategoryClick = (key) => {
    setActiveSubcategory(key);
    setActiveOption(null);
  };

  const handleOptionClick = (key) => {
    setActiveOption(key);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => setSelectedProduct(null);

  // Renderers
  const renderTabs = () => (
    <div className="flex flex-wrap border-b border-gray-200 mb-6">
      {Object.entries(ceiling_cladding).map(([key, category]) => (
        <button
          key={key}
          onClick={() => handleCategoryClick(key)}
          className={`px-4 py-2 font-medium text-sm md:text-base ${activeCategory === key
            ? "border-b-2 border-blue-500 text-blue-600"
            : "text-gray-500 hover:text-gray-700"
            }`}
        >
          {category.name}
        </button>
      ))}
    </div>
  );

  const renderSubcategories = () => {
    if (!activeCategory) return null;
    const category = ceiling_cladding[activeCategory];
    if (!category.subcategories) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(category.subcategories).map(([key, sub]) => (
            <button
              key={key}
              onClick={() => handleSubcategoryClick(key)}
              className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
            >
              {sub.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderOptions = () => {
    if (!activeCategory || !activeSubcategory) return null;
    const sub = ceiling_cladding[activeCategory].subcategories[activeSubcategory];
    if (!sub.subcategories) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(sub.subcategories).map(([key, opt]) => (
            <button
              key={key}
              onClick={() => handleOptionClick(key)}
              className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
            >
              {opt.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderProducts = () => {
    let products = [];
    if (activeCategory && activeSubcategory && activeOption) {
      products =
        ceiling_cladding[activeCategory].subcategories[activeSubcategory]
          .subcategories[activeOption].products || [];
    } else if (activeCategory && activeSubcategory) {
      products =
        ceiling_cladding[activeCategory].subcategories[activeSubcategory]
          .products || [];
    }

    if (!products.length)
      return (
        <div className="text-center py-10 text-gray-500">
          No products available
        </div>
      );

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p, idx) => (
          <div
            key={idx}
            className="border rounded-lg shadow hover:shadow-lg cursor-pointer"
            onClick={() => handleProductClick(p)}
          >
            <img
              src={p.image}
              alt={p.name}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="font-semibold text-lg">{p.name}</h3>
              <p className="text-gray-600">{p.use}</p>
              {/* <p className="text-blue-600 font-bold">{p.price}</p> */}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderModal = () =>
    selectedProduct && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg max-w-lg w-full overflow-hidden">
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-xl font-bold">{selectedProduct.name}</h2>
            <button onClick={closeModal}>&times;</button>
          </div>
          <img
            src={selectedProduct.image}
            alt={selectedProduct.name}
            className="w-full h-64 object-cover"
          />
          <div className="p-4 space-y-2">
            <p>
              <strong>Uses:</strong> {selectedProduct.use}
            </p>
            <p>
              <strong>Details:</strong> {selectedProduct.details}
            </p>

          </div>
          <div className="p-4 flex justify-end border-t">
            <button
              onClick={closeModal}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );

  return (
    <>
      <ProductsNavRow />
      <div className="container mx-auto px-4 sm:px-6 py-4 w-full max-w-full overflow-x-hidden">
        <h1 className="text-2xl md:text-3xl font-bold mb-4 text-center md:text-left text-gray-800">Ceiling, Cladding & Partitioning</h1>
        {renderTabs()}
        {renderSubcategories()}
        {renderOptions()}
        {renderProducts()}
        {renderModal()}
      </div>
    </>
  );
};

export default CeilingClading;
